import { useInternalDynamicContext } from '../../../context/DynamicContext/useInternalDynamicContext.js';
import { useOnlyConnectedMode } from '../useOnlyConnectedMode/useOnlyConnectedMode.js';
import { getUserProfileFields } from '../../functions/getUserProfileFields/getUserProfileFields.js';

const isSocialEnabled = (kyc = []) => { var _a; return Boolean((_a = kyc.find(({ name }) => name === 'social')) === null || _a === void 0 ? void 0 : _a.enabled); };
/**
 * A custom React hook that checks if KYC fields are enabled in the project settings or defined in the user profile.
 *
 * @returns {boolean} - A boolean value indicating whether the KYC fields are enabled in the project settings or defined in the user profile.
 */
const useKYCFlag = () => {
    const isOnlyConnectedMode = useOnlyConnectedMode();
    const { projectSettings, user } = useInternalDynamicContext();
    if (isOnlyConnectedMode)
        return false;
    const hasAnyKYCFields = getUserProfileFields({
        projectSettingsKyc: projectSettings === null || projectSettings === void 0 ? void 0 : projectSettings.kyc,
        user,
    });
    return hasAnyKYCFields.length > 0 || isSocialEnabled(projectSettings === null || projectSettings === void 0 ? void 0 : projectSettings.kyc);
};

export { useKYCFlag };
